<template>
    <div class="generate-invoice-check form-check">
        <input :id="id" type="checkbox" class="form-check-input" v-model="checked">
        <label :for="id" class="form-check-label">
            Cocher cette case pour sélectionner cette facture
        </label>

        <template v-if="checked">
            <input v-for="order in orders" type="hidden" name="orders[]" :value="order">
        </template>
    </div>
</template>

<script>

export default {
    name: "GenerateInvoiceCheck",

    props: {
        id: {
            type: String,
            required: true,
        },
        orders: {
            type: Array,
            required: true,
        }
    },

    data() {
        return {
            checked: true,
        };
    },
}
</script>
